<template>
  <div>
    <horarios-superpuestos ref="superpuestos"></horarios-superpuestos>

    <calendario-horario ref="calendario"></calendario-horario>

    <alumno-cursado-form
      ref="form"
      :id="id"
      @close="cerrar"
    ></alumno-cursado-form>
    <v-card>
      <v-card-title>
        <div>
          <div>Espacio: {{ cursado.espacio.searchTag }}</div>
          <div>Comision: {{ cursado.comision }}</div>
          <div v-if="cursado.nombreAulaCampus" class="caption grey--text">
            Aula Campus: {{ cursado.nombreAulaCampus }}
          </div>
          <!-- Inscripción Campus -->
          <v-card outlined class="mt-2 pa-2">
            <div class="d-flex align-center flex-wrap">
              <v-autocomplete
                v-model="ofertaIdSeleccionada"
                :items="ofertas"
                item-value="oferta_id"
                item-text="nombre_curso"
                label="Aula Campus"
                outlined
                dense
                hide-details
                :loading="loadingOfertas"
                style="max-width: 400px"
                class="mr-3"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.nombre_curso
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >ID: {{ item.oferta_id }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-btn
                icon
                color="primary"
                :disabled="!ofertaIdSeleccionada"
                :href="urlAulaSeleccionada"
                target="_blank"
                title="Abrir aula en campus"
                class="mr-2"
              >
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
              <v-btn
                color="orange"
                dark
                :loading="inscribiendo"
                :disabled="!ofertaIdSeleccionada || selectedItems.length === 0"
                @click="inscribirSeleccionados"
              >
                <v-icon left>mdi-account-multiple-plus</v-icon>
                Inscribir Seleccionados ({{ selectedItems.length }})
              </v-btn>
            </div>
          </v-card>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col align="left">
            <v-btn @click="newItem" color="primary">Nuevo</v-btn>
          </v-col>
          <v-col>
            <div>
              <download-excel :name="filename" :data="excel">
                <v-btn dark color="success">Exportar</v-btn>
              </download-excel>
            </div>
          </v-col>
          <!--          <v-col>-->
          <!--            <div>-->
          <!--              <download-excel :data="campus">-->
          <!--                <v-btn dark color="primary">Exportar Campus</v-btn>-->
          <!--              </download-excel>-->
          <!--            </div>-->
          <!--          </v-col>-->
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Buscar por campo"
              v-model="search.tag"
              clearable
              @click:clear="reload"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100, 200, 500],
          }"
          v-model="selectedItems"
          show-select
          :loading="loading.status"
          :items="alumnoCursados"
          :headers="headers"
          :server-items-length="pagination.totalCount"
          :options.sync="options"
        >
          <template v-slot:body.prepend>
            <filter-row ref="filterRow" :headers="headers" @reload="reload">
            </filter-row>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              x-small
              color="orange"
              dark
              class="mr-1"
              @click="inscribirAlumnoIndividual(item)"
              :title="
                item.ofertaIdCampusSugerido
                  ? 'Aula sugerida: ' + item.ofertaIdCampusSugerido
                  : 'Sin aula sugerida'
              "
            >
              <v-icon x-small>mdi-school</v-icon>
            </v-btn>
            <v-icon color="info" class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="info" @click="deleteItem(item.id)">
              mdi-delete
            </v-icon>
            <whatsapp-button :telefono="item.alumno.telefono"></whatsapp-button>
          </template>

          <template v-slot:item.inscripto_campus="{ item }">
            <v-icon v-if="item.inscripto_campus" color="success" small
              >mdi-check-circle</v-icon
            >
            <v-icon v-else color="grey lighten-1" small
              >mdi-circle-outline</v-icon
            >
          </template>

          <template v-slot:item.superpuesto="{ item }">
            <div v-if="item.cursadosSuperpuestos.length > 0">
              <v-btn @click="verSuperpuestos(item)" color="error">SI</v-btn>
            </div>
            <div v-else>
              <v-btn @click="verHorarios(item)" color="success">No</v-btn>
            </div>
          </template>
          <template v-slot:item.alumno_cursado.created_at="{ item }">
            {{ item.creado }}
          </template>
          <template v-slot:item.alumno_cursado.id="{ item }">
            {{ item.id }}
          </template>
          <template v-slot:item.u_curricular_carrera.nombre="{ item }">
            {{ item.cursado.espacio.searchTag }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FilterRow from "@/viewsNew/utils/FilterRow";
import { mapMutations, mapActions, mapState } from "vuex";
import AlumnoCursadoForm from "@/viewsNew/alumno-cursado/AlumnoCursadoForm";
import WhatsappButton from "@/viewsNew/utils/WhatsappButton";
import HorariosSuperpuestos from "@/viewsNew/alumno-cursado/HorariosSuperpuestos";
import CalendarioHorario from "@/viewsNew/cursado/CalendarioHorario";
import Campus from "@/apis/Campus";

export default {
  name: "AlumnoCursadoABM",
  props: {
    cursado_id: [String, Number],
  },
  components: {
    CalendarioHorario,
    HorariosSuperpuestos,
    WhatsappButton,
    AlumnoCursadoForm,
    FilterRow,
  },
  data() {
    return {
      selectedItems: [],
      like: {},
      dialog: false,
      id: null,
      options: {
        // itemsPerPage:-1,
        joins: ["alumno"],
      },
      expand: [
        // "userCampus",
        "alumno",
        "cursado",
        "cursadosSuperpuestos",
        "user",
        "otrosCursados",
      ],
      filters: {},
      // Campus inscription
      ofertas: [],
      loadingOfertas: false,
      inscribiendo: false,
      ofertaIdSeleccionada: null,
    };
  },
  computed: {
    ...mapState("NewCursadoModule", ["cursado"]),
    ...mapState("NewAlumnoCursadoModule", ["alumnoCursados", "pagination"]),
    ...mapState(["search", "loading", "dialogs"]),

    filename() {
      return (
        this.cursado.espacio.searchTag + "-comision_" + this.cursado.comision
      );
    },

    // campus() {
    //   const data = [];
    //   for (var i in this.alumnoCursados) {
    //     let alumno = this.alumnoCursados[i];
    //     var registro = {
    //       username: alumno.userCampus.usuario,
    //     };
    //     data.push(registro);
    //   }
    //
    //   return data;
    // },

    excel() {
      const data = [];
      for (var i in this.alumnoCursados) {
        let alumno = this.alumnoCursados[i];
        var registro = {
          id: alumno.id,
          creado: alumno.creado,
          nombre: alumno.alumno.nombre,
          apellido: alumno.alumno.apellido,
          email: alumno.alumno.email,
          dni: alumno.alumno.dni,
          telefono: alumno.alumno.telefono,
          superpuestos: alumno.cursadosSuperpuestos.length,
          // carrera: alumno.carrera.codigo,
          rol: alumno.alumno.roles,
          cursado: alumno.cursado.espacio.searchTag,
        };
        data.push(registro);
      }
      return data;
    },

    urlAulaSeleccionada() {
      if (!this.ofertaIdSeleccionada) return null;
      return `https://ifdsao-rng.infd.edu.ar/aula/catalogo.cgi?wAccion=oferta_view&oferta_id=${this.ofertaIdSeleccionada}`;
    },

    filterHeaders() {
      return this.headers.filter((el) => el.filterable);
    },

    headers() {
      return [
        { text: "Id", value: "alumno_cursado.id", filterable: true },
        // { text: "User Campus", value: "userCampus.usuario", filterable: true },
        // { text: "Email Campus", value: "userCampus.email", filterable: true },
        {
          text: "Creado",
          value: "alumno_cursado.created_at",
          filterable: true,
        },
        {
          text: "Espacio",
          value: "u_curricular_carrera.nombre",
          filterable: false,
          nosearch: true,
        },
        { text: "DNI", value: "user.dni", filterable: true },
        { text: "Apellido", value: "user.apellido", filterable: true },
        { text: "Nombre", value: "user.nombre", filterable: true },
        { text: "Email", value: "user.email", filterable: true },
        { text: "Telefono", value: "user.telefono", filterable: true },
        {
          text: "Campus",
          value: "inscripto_campus",
          filterable: false,
          nosearch: true,
          align: "center",
        },
        {
          text: "Superpuesto",
          value: "superpuesto",
          filterable: false,
          nosearch: true,
        },
        {
          text: "Acciones",
          value: "actions",
          filterable: false,
          nosearch: true,
        },
      ];
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$refs.form.model = {};
        this.id = null;
      }
    },
    filters: {
      handler() {
        this.setFilters();
        this.reload();
      },
      deep: true,
    },
    like: {
      handler() {
        this.reload();
      },
      deep: true,
    },

    search: {
      handler() {
        this.setSearch();
        this.reload();
      },
      deep: true,
    },

    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    // Establecer oferta por defecto cuando se carga el cursado
    "cursado.ofertaIdCampus": {
      handler(newVal) {
        if (newVal && !this.ofertaIdSeleccionada) {
          this.ofertaIdSeleccionada = newVal;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("NewCursadoModule", ["getCursado"]),
    ...mapActions("NewAlumnoCursadoModule", [
      "getAlumnoCursados",
      "deleteAlumnoCursado",
    ]),
    ...mapMutations(["clearFilters", "setFilters", "setSearch"]),

    newItem() {
      this.$refs.form.model = {};
      this.$refs.form.dialog = true;
    },

    cerrar() {
      this.$refs.form.dialog = false;
      this.reload();
    },

    editItem(item) {
      this.id = item.id;
      this.$refs.form.dialog = true;
    },
    async deleteItem(id) {
      const res = await this.$dialog.confirm({
        color: "error",
        icon: "mdi-alert",
        text: "Esta seguro que desea eliminar el registro?",
        title: "Eliminar Registro",
      });
      if (res) {
        this.deleteAlumnoCursado(id);
      }
    },

    async reload() {
      this.getCursado({
        id: this.cursado_id,
        expand: "aulaCampusUrl,ofertaIdCampus,nombreAulaCampus",
      });
      this.loading.status = true;
      this.filters.cursado_id = this.cursado_id;
      await this.getAlumnoCursados({
        like: this.$refs.filterRow.like,
        options: this.options,
        filters: this.filters,
        expand: this.expand.toString(),
        search: this.search.tag,
        headers: this.headers,
      });
      this.loading.status = false;
    },
    verSuperpuestos(item) {
      // this.$refs.superpuestos.dialog = true;
      // this.$refs.superpuestos.cursados = item.cursadosSuperpuestos;
      this.$refs.calendario.dialog = true;
      this.$refs.calendario.cursos = [
        item.cursado,
        ...item.cursadosSuperpuestos,
      ];
    },
    verHorarios(item) {
      this.$refs.calendario.dialog = true;
      this.$refs.calendario.cursos = item.otrosCursados;
    },

    async cargarOfertas() {
      if (this.ofertas.length === 0) {
        this.loadingOfertas = true;
        try {
          const response = await Campus.getOfertas();
          if (response.success) {
            this.ofertas = response.ofertas;
          }
        } catch (error) {
          console.error("Error cargando ofertas:", error);
        }
        this.loadingOfertas = false;
      }
    },

    async inscribirAlumnoIndividual(item) {
      // Obtener el aula sugerida o la del cursado
      const ofertaId =
        item.ofertaIdCampusSugerido ||
        this.cursado.ofertaIdCampus ||
        this.ofertaIdSeleccionada;

      if (!ofertaId) {
        this.$dialog.error({
          text:
            "No hay un aula del campus asignada. Seleccione un aula primero.",
          title: "Error",
        });
        return;
      }

      // Buscar el nombre del aula
      const oferta = this.ofertas.find((o) => o.oferta_id === ofertaId);
      const nombreAula = oferta ? oferta.nombre_curso : `ID: ${ofertaId}`;

      const res = await this.$dialog.confirm({
        color: "orange",
        icon: "mdi-school",
        text: `¿Inscribir a ${item.alumno.apellido}, ${item.alumno.nombre} en "${nombreAula}"?`,
        title: "Inscribir en Campus",
      });

      if (!res) return;

      this.inscribiendo = true;
      try {
        const response = await Campus.inscribir(
          item.alumno.dni,
          ofertaId,
          item.id
        );

        if (response.success) {
          // Actualizar el item localmente
          item.inscripto_campus = 1;
          item.oferta_id_campus = ofertaId;
          this.$dialog.message.success("Inscripcion exitosa en el campus", {
            position: "top-right",
          });
        } else {
          this.$dialog.error({
            text: response.error || "Error al inscribir en el campus",
            title: "Error",
          });
        }
      } catch (error) {
        this.$dialog.error({
          text:
            error.response?.data?.error || "Error al inscribir en el campus",
          title: "Error",
        });
      }
      this.inscribiendo = false;
    },

    async inscribirSeleccionados() {
      if (!this.ofertaIdSeleccionada) {
        this.$dialog.error({
          text: "Debe seleccionar un aula del campus",
          title: "Error",
        });
        return;
      }

      if (this.selectedItems.length === 0) {
        this.$dialog.warning({
          text: "Debe seleccionar al menos un alumno",
          title: "Atencion",
        });
        return;
      }

      // Buscar el nombre del aula
      const oferta = this.ofertas.find(
        (o) => o.oferta_id === this.ofertaIdSeleccionada
      );
      const nombreAula = oferta
        ? oferta.nombre_curso
        : `ID: ${this.ofertaIdSeleccionada}`;

      const res = await this.$dialog.confirm({
        color: "orange",
        icon: "mdi-account-multiple-plus",
        text: `¿Inscribir ${this.selectedItems.length} alumno(s) en "${nombreAula}"?`,
        title: "Inscribir en Campus",
      });

      if (!res) return;

      this.inscribiendo = true;

      // Preparar datos para inscripción múltiple optimizada
      const inscripciones = this.selectedItems.map((item) => ({
        dni: item.alumno.dni,
        alumno_cursado_id: item.id,
      }));

      try {
        const response = await Campus.inscribirMultiples(
          inscripciones,
          this.ofertaIdSeleccionada
        );

        if (response.summary) {
          // Actualizar los items localmente para los exitosos
          for (const result of response.results) {
            if (result.success) {
              const item = this.selectedItems.find(
                (i) => i.alumno.dni == result.dni
              );
              if (item) {
                item.inscripto_campus = 1;
                item.oferta_id_campus = this.ofertaIdSeleccionada;
              }
            }
          }

          this.$dialog.message.success(
            `Inscripcion completada: ${response.summary.exitosos} exitosos, ${response.summary.fallidos} fallidos`,
            { position: "top-right" }
          );
        }
      } catch (error) {
        this.$dialog.error({
          text:
            error.response?.data?.error || "Error al inscribir en el campus",
          title: "Error",
        });
      }

      // Limpiar selección
      this.selectedItems = [];
      this.inscribiendo = false;
    },
  },
  async created() {
    // Cargar ofertas al iniciar
    await this.cargarOfertas();
  },
  destroyed() {
    this.clearFilters();
  },
};
</script>

<style scoped></style>
